import type { ConclusionGrade, PhaseCommonDto, PhaseFigureDto } from './fasi';
import type { PhaseHelpDto } from './fase4';

/**
 * La fase 5 «Gli impianti» del contratto n. 1 versione 2.4 (art. 8, fase 5; art. 3.101-3.102; ADR 0176), nella forma della
 * pagina di prova `docs/mockup/percorso-sinapsi/08-fase5`: per ogni sede gli impianti nei tre gruppi, presenti o
 * probabili con la fonte, di chi sono (dal titolo d'uso), il registro con la cadenza, nessuna norma; il conto per sede e
 * per gruppo; lo scarto; le cose che aiuterebbero qui; le domande sugli impianti probabili che cambiano un obbligo.
 */

/** I tre gruppi di impianti (art. 3.101), nell'ordine della pagina. */
export const PLANT_GROUPS = ['impianti_edificio', 'attrezzature', 'dotazioni_informatiche'] as const;
export type PlantGroup = (typeof PLANT_GROUPS)[number];
export const PLANT_GROUP_TEXT: Record<PlantGroup, string> = {
  impianti_edificio: 'Impianti dell’edificio',
  attrezzature: 'Attrezzature di lavoro',
  dotazioni_informatiche: 'Dotazioni informatiche',
};

export interface PhasePlantDto {
  id: string;
  nome: string;
  descrizione: string;
  gruppo: PlantGroup;
  /** Quanti, quando le fonti lo dicono («Furgoni attrezzati · 6»). */
  quantita: number | null;
  presenza: 'presente' | 'probabile';
  /** La fonte per nome con il grado, o lo strato, con la citazione breve. */
  fonte: string;
  di_chi: 'azienda' | 'proprietario';
  /** Il registro in parole: cosa, ogni quanto, chi (art. 3.102); «—» quando non ne ha. */
  registro: string | null;
  grado: ConclusionGrade;
  /** Una risposta o una correzione del titolare già portata nella voce. */
  nota: string | null;
}

export interface PhasePlantSiteDto {
  /** L'id della sede (fase 2). */
  id: string;
  nome: string;
  /** «Di proprietà», «In affitto», «Titolo d'uso da confermare». */
  titolo_uso: string;
  /** La fonte del titolo d'uso: «Risposta del titolare · T», «Scelta di Timonio». */
  titolo_uso_fonte: string;
  /** Uso della sede e di chi sono gli impianti dell'edificio, in una frase. */
  nota: string | null;
  gruppi: Array<{ gruppo: PlantGroup; titolo: string; impianti: PhasePlantDto[] }>;
  /** Il conto della sede: in tutto e per gruppo. */
  conto: { totale: number; per_gruppo: Record<PlantGroup, number> };
  /** «L'edificio al referente di sede, il resto a chi lo usa»: il tipo di ruolo; lo assegna la fase 8. */
  responsabile: string;
}

export interface PhaseFiveDto extends PhaseCommonDto {
  fase: 5;
  numeri: PhaseFigureDto[];
  sedi: PhasePlantSiteDto[];
  aiuterebbero: PhaseHelpDto[];
}
